/** Query params for opening a user profile in a specific enrollment (UGP) context. */

export function getProfileEnrollmentFromSearchParams(searchParams) {
  const sp = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
  return {
    userGroupsPeriodsId: sp.get('user_groups_periods_id') || sp.get('ugp_id'),
    groupsPeriodsId: sp.get('groups_periods_id')
  };
}

/** Deep-link into Custom Forms assignment viewer on a user profile. */
export function getProfileAssignmentFromSearchParams(searchParams) {
  const sp = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
  const formId = sp.get('form_id') || sp.get('assignment_form_id');
  const relationshipId = sp.get('relationship_id') || sp.get('form_assignment_id');
  const submissionId = sp.get('submission_id') || sp.get('form_submission_id');
  const openFlag = sp.get('open_assignment');
  const openAssignment =
    openFlag === '1' ||
    openFlag === 'true' ||
    !!(formId || relationshipId);

  return {
    formId,
    relationshipId,
    submissionId,
    openAssignment
  };
}

export function resolveEnrollmentGroupsPeriodsId(groupsPeriods, { userGroupsPeriodsId, groupsPeriodsId } = {}) {
  const list = (groupsPeriods || []).filter((gp) => gp.groups_periods_id);
  if (!list.length) return null;

  if (userGroupsPeriodsId) {
    const byUgp = list.find((gp) => String(gp.id) === String(userGroupsPeriodsId));
    if (byUgp) return String(byUgp.groups_periods_id);
  }
  if (groupsPeriodsId) {
    const byGp = list.find((gp) => String(gp.groups_periods_id) === String(groupsPeriodsId));
    if (byGp) return String(groupsPeriodsId);
  }
  return null;
}

export function buildUserProfileUrl({
  userId,
  userGroupsPeriodsId,
  groupsPeriodsId,
  from,
  formId,
  relationshipId,
  submissionId,
  openAssignment = false
}) {
  if (!userId) return '/user-profiles';
  const params = new URLSearchParams();
  params.set('id', String(userId));
  if (userGroupsPeriodsId) {
    params.set('user_groups_periods_id', String(userGroupsPeriodsId));
  } else if (groupsPeriodsId) {
    params.set('groups_periods_id', String(groupsPeriodsId));
  }
  if (formId) params.set('form_id', String(formId));
  if (relationshipId) params.set('relationship_id', String(relationshipId));
  if (submissionId) params.set('submission_id', String(submissionId));
  if (openAssignment || formId || relationshipId) {
    params.set('open_assignment', '1');
  }
  if (from) params.set('from', from);
  return `/user-profiles?${params.toString()}`;
}

/** Profile URL that opens a form assignment (and optional submission) in the assignment viewer. */
export function buildUserProfileAssignmentUrl({
  userId,
  userGroupsPeriodsId,
  groupsPeriodsId,
  formId,
  relationshipId,
  submissionId,
  from
}) {
  return buildUserProfileUrl({
    userId,
    userGroupsPeriodsId,
    groupsPeriodsId,
    formId,
    relationshipId,
    submissionId,
    openAssignment: true,
    from
  });
}
